import { Field, Text } from "@sitecore-jss/sitecore-jss-react";
import React from "react";

import { dlpInsuranceTypes } from "../../Enums/enumValues";
import { Enum } from "../../interfaces/enum";
import { formatCurrency } from "../../lib/currencyUtil";
import { Coverage, DlpState, Premium } from "../../providers/dlpFlow/DlpFlow.interfaces";
import { currencyThousandFormat } from "../InputFields/sanitizer/currencyFormat";
import { SummaryTable } from "../summary/SummaryTable";

interface Props {
  index: number;
  fields: Record<string, Field<string>>;
  coverage: Partial<Coverage>;
  data: DlpState;
  dictionary: Record<string, string>;
  premiumPerPaymentTerm?: Premium;
}

export const DlpSummaryCoverageData = ({ index, fields, coverage, data, dictionary, premiumPerPaymentTerm }: Props) => {
  const duration = coverage.duration;
  const amount = coverage.insuredAmount;

  const insuranceTypeValue = (dlpInsuranceTypes() as Enum[]).filter((x) => x.value === coverage.insuranceType);
  const insuranceType = insuranceTypeValue.length ? insuranceTypeValue[0].label : undefined;

  const percentage = coverage.insuranceType === "Annuity" ? coverage.reductionRate : undefined;
  const convertedPaymentTerm = dictionary[`paymentTerm.${data.paymentTerm.toLowerCase()}`] ?? data.paymentTerm;

  const insuranceTitleId = `DlpSummaryCoverage-insurance-title`;

  const showCoverageData = amount || duration || insuranceType;
  const showPercentage = insuranceType && percentage;

  return (
    <SummaryTable aria-labelledby={insuranceTitleId}>
      <thead>
        <tr>
          <th colSpan={2} id={insuranceTitleId}>
            <Text field={fields.InsuranceTitle}></Text>
          </th>
        </tr>
      </thead>
      {showCoverageData && (
        <tbody>
          {amount ? (
            <tr>
              <th id={`coverage_amount_label_${index + 1}`}>
                <Text field={fields.InsuranceAmountLabel}></Text>
              </th>
              <td id={`coverage_amount_value_${index + 1}`}>{currencyThousandFormat(amount)}</td>
            </tr>
          ) : null}
          {duration ? (
            <tr>
              <th id={`coverage_duration_label_${index + 1}`}>
                <Text field={fields.InsuranceDurationLabel}></Text>
              </th>
              <td id={`coverage_duration_value_${index + 1}`}>{duration} jaar</td>
            </tr>
          ) : null}
          {insuranceType ? (
            <tr>
              <th id={`coverage_type_label_${index + 1}`}>
                <Text field={fields.InsuranceTypeLabel}></Text>
              </th>
              <td id={`coverage_type_value_${index + 1}`}>{insuranceType}</td>
            </tr>
          ) : null}
          {showPercentage ? (
            <tr>
              <th id={`coverage_annuity_percentage_label_${index + 1}`}>
                <Text field={fields.AnnuityPercentageLabel}></Text>
              </th>
              <td id={`coverage_annuity_percentage_value_${index + 1}`}>{percentage}&nbsp;%</td>
            </tr>
          ) : null}
          {premiumPerPaymentTerm ? (
            <tr>
              <th id={`coverage_premium_label_${index + 1}`}>
                <Text field={fields.PremiumLabel}></Text>
              </th>
              <td id={`coverage_premium_value_${index + 1}`}>{`${formatCurrency(
                premiumPerPaymentTerm.premium
              )} ${convertedPaymentTerm.toLowerCase()}`}</td>
            </tr>
          ) : null}
        </tbody>
      )}
    </SummaryTable>
  );
};
